<template>
    <HeroSection :featureName="baseFeature.name" :icon="baseFeature.icon">
        <template #title>{{ baseFeature.description }}</template>
        <template #description>

            <p class="">Build custom event websites with our drag-and-drop builder. Add content blocks which use data from your event, including sessions, speakers, sponsors and exhibitors.</p>
            <p class="mt-4">Launch in seconds on an entegy domain, or BYO domain at no extra cost with automated SSL Certificates.</p>
        </template>
        <template #content>   
            <div class="h-[300px] relative overflow w-full">         
                <DeviceWrapper deviceType="laptop" :width="100" :x="0" :y="-10" :z="0" :rotateOnScroll="true" :imageSrc="websiteImages[websiteIndex]" />
            </div>
        </template>
    </HeroSection>

    <CmsLarge title="Website Builder" copy="Add pages, design navigation and add content blocks to build your event website. Publish changes to a staging URL for preview before going live." :imageSrc="builder" />

    <Tips :title="baseFeature.name" :tips="tips" />
    <WorksWith :title="baseFeature.name" :integrations="integrations" />
    <Cta />
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import Cta from '../../components/Blocks/Cta.vue';
import HeroSection from '../../components/HeroSection.vue';
import Tips from '../../components/Blocks/Tips.vue';
import WorksWith from '../../components/Blocks/WorksWith.vue';
import DeviceWrapper from '@/components/DeviceWrapper.vue';
import CmsLarge from '@/components/Layouts/CmsLarge.vue';
import { getFeaturesByIds } from '@/router/features';

import builder from '@/images/screenshots/cms/website-builder.png';

import websiteImage1 from '@/images/screenshots/web/theme-1-website-home.png';
import websiteImage2 from '@/images/screenshots/web/theme-1-website-speakers.png';
import websiteImage3 from '@/images/screenshots/web/theme-1-website-schedule.png';
import websiteImage4 from '@/images/screenshots/web/theme-1-website-exhibitors.png';

const websiteImages = [websiteImage1, websiteImage2, websiteImage3, websiteImage4];
const websiteIndex = ref(0);

const ROTATE_INTERVAL_MS = 4000;
let rotateTimer = null;

onMounted(() => {
    rotateTimer = setInterval(() => {
        websiteIndex.value = (websiteIndex.value + 1) % websiteImages.length;
    }, ROTATE_INTERVAL_MS);
});

onUnmounted(() => {
    if (rotateTimer) clearInterval(rotateTimer);
});

const tips = [
    'Advanced designers can extend the theme with custom CSS',
    'Use Schedule Views and Tags to filter what sessions are shown on your website.'
];

const baseFeature = getFeaturesByIds(['websitesbuilder'])[0];
const integrations = getFeaturesByIds(['eventapp', 'registrationandtickets', 'companyportals']);
</script>
